export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12592.3397c19e.jpg";